export const translations = {
  en: {
    question_text_1: 'Have you experienced any of the following symptoms in the past 14 days?',
    instructions: 'Please select all that apply.',
    question_text_2: 'When did you first start having symptoms?',
    date_format: 'MM/DD/YYYY',
    checkbox_1: 'Fever',
    checkbox_2: 'Cough',
    checkbox_3: 'Shortness of breath',
    checkbox_4: 'Fatigue or body aches',
    checkbox_5: 'Sore throat',
    checkbox_6: 'Runny nose',
    checkbox_7: 'Loss of smell',
    checkbox_8: 'Diarrhea',
    checkbox_9: 'None of the above',
    error_1: 'Invalid Date Format',
    error_2: 'Please enter a valid date'
  },
  es: {
    question_text_1: '¿Ha experimentado cualquiera de estos síntomas en los últimos 14 días?',
    instructions: 'Seleccione todas las opciones que correspondan.',
    question_text_2: '¿Cuándo empezó a tener los síntomas?',
    date_format: 'MM/DD/AAAA',
    checkbox_1: 'Fiebre',
    checkbox_2: 'Tos',
    checkbox_3: 'Falta de aire',
    checkbox_4: 'Fatiga o dolores musculares',
    checkbox_5: 'Dolor de garganta',
    checkbox_6: 'Escurrimiento nasal',
    checkbox_7: 'Pérdida del sentido del olfato',
    checkbox_8: 'Diarrea',
    checkbox_9: 'Ninguno',
    error_1: 'Formato de fecha inválido',
    error_2: 'Introduzca una fecha válida'
  }
};
